import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {EMPTY} from 'rxjs';
import {DirectHitSelectors, SupplierImplementation} from './model';
import {environment} from '../environments/environment';

const TOKEN_KEY = 'bp_auth_token';

@Injectable({
  providedIn: 'root'
})
export class AutoScraperBackendService {
  public supplier_implementation!: SupplierImplementation;
  public baseline_direct_hits_selectors: DirectHitSelectors | null = null;
  public token: string = '';
  public is_logged_in: boolean = false;
  public save_status: string = '';

  constructor(public http: HttpClient) {
    const stored = localStorage.getItem(TOKEN_KEY);
    if (stored) {
      this.token = stored;
      this.is_logged_in = true;
    }
  }

  setToken(token: string): void {
    this.token = token;
    this.is_logged_in = true;
    localStorage.setItem(TOKEN_KEY, token);
  }

  logout(): void {
    this.token = '';
    this.is_logged_in = false;
    this.supplier_implementation = null!;
    localStorage.removeItem(TOKEN_KEY);
  }

  saveImplementation(): void {
    if (!this.supplier_implementation?.basic_supplier_info?.name) {
      this.save_status = 'Error: empty supplier name.';
      return;
    }
    this.save_status = 'Saving...';
    const headers = new HttpHeaders({'auth': this.token});
    this.http.post(environment.apiUrl + '/save_implementation', this.supplier_implementation, {headers}).pipe(
      catchError(() => {
        this.save_status = 'Error';
        return EMPTY;
      })
    ).subscribe(res => {
      if (res === 'Unauthorized.') {
        this.save_status = 'Unauthorized.';
        return;
      }
      if (typeof res === 'string') {
        this.save_status = res;
        return;
      }
      this.supplier_implementation = res as SupplierImplementation;
      this.baseline_direct_hits_selectors = JSON.parse(JSON.stringify(this.supplier_implementation.direct_hits_selectors));
      this.save_status = 'Saved';
    });
  }
}
